import request from '@/shared/api/request';

/**
 *
 * Creates account.
 *
 * @returns {Promise}
 */
export const register = (data: { email: string; password: string }): Promise<{ token: string }> =>
  request({
    url: '/account/register/',
    method: 'POST',
    withCredentials: true,
    data,
  });
